import { useQuery } from "@tanstack/react-query";
import { configuration } from "../../../../configuration";
import { FetchError } from "../../../types";
import { GetMeetingNotesDto } from "../../../types/meetings/notes";
import { useAccessToken } from "../../../use-access-token";
import { queryKeys } from "../../queryKeys";

const useGetSharedMeetingNotesRequest = (meetingGuid: string) => {
  const { getAccessToken } = useAccessToken();

  async function getSharedMeetingNotesRequest(): Promise<GetMeetingNotesDto> {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/meetings/${meetingGuid}/shared-notes`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getSharedMeetingNotesRequest };
};

const useGetSharedMeetingNotes = (meetingGuid: string) => {
  const { getSharedMeetingNotesRequest } = useGetSharedMeetingNotesRequest(meetingGuid);

  return useQuery({
    queryKey: queryKeys.meetings.getSharedMeetingNotes(meetingGuid),
    queryFn: getSharedMeetingNotesRequest,
  });
};

export { useGetSharedMeetingNotes };
